





























import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherLayout from '../../components/TedsLauncherLayout/TedsLauncherLayout.vue'
import TedsLauncherProfileInformation from '../../components/TedsLauncherProfileInformation/TedsLauncherProfileInformation.vue'
import TedsLauncherNotch from '../../components/TedsLauncherNotch/TedsLauncherNotch.vue'
import TedsLauncherLinkCard from '../../components/TedsLauncherLinkCard/TedsLauncherLinkCard.vue'
import TedsLogo from '../../components/TedsLogo/TedsLogo.vue'
import { LauncherLink } from '../../../../app/httpSettings/LauncherLinks'
import { userSatisfiesLauncherLinkRules } from '@/app/httpSettings/launcherLinkFunctions'

@Component({
  components: {
    TedsLauncherLayout,
    TedsLauncherProfileInformation,
    TedsLauncherNotch,
    TedsLauncherLinkCard,
    TedsLogo,
  },
})
export default class TedsLauncherMain extends Vue {
  public currentYear: number = new Date().getFullYear()

  generateLinks(links: Array<LauncherLink>): Array<LauncherLink> {
    const tedsUiOptions = this.$launcher.bootState.tedsUi.options
    const checkAccessForUserFn = userSatisfiesLauncherLinkRules(tedsUiOptions)(this.$launcher.user)
    return links.filter(link => checkAccessForUserFn(link.rules))
  }
}
